
// src/components/exams/ExamManagement/index.js
import React, { useState } from 'react';
import ExamsList from './ExamsList';
import CreateExam from './CreateExam';
import ViewExam from './ViewExam';

const ExamManagement = ({ 
  exams, 
  questionBank,
  onCreateExam, 
  onDeleteExam, 
  onCreateTest,
  onEditTest 
}) => {
  const [currentView, setCurrentView] = useState('list');
  const [selectedExam, setSelectedExam] = useState(null);

  const handleCreateExam = () => {
    setCurrentView('create');
  };

  const handleViewExam = (exam) => {
    setSelectedExam(exam);
    setCurrentView('view');
  };

  const handleExamCreated = (examData) => {
    onCreateExam(examData);
    setCurrentView('list');
  };

  const handleCreateTest = () => {
    onCreateTest(selectedExam);
  };

  const handleEditTest = (test) => {
    onEditTest(selectedExam, test);
  };

  const handleBack = () => {
    setCurrentView('list');
    setSelectedExam(null);
  };

  switch (currentView) {
    case 'create':
      return (
        <CreateExam 
          onCreateExam={handleExamCreated}
          onCancel={handleBack}
        />
      );
    
    case 'view':
      return (
        <ViewExam 
          exam={selectedExam}
          questionBank={questionBank}
          onBack={handleBack}
          onCreateTest={handleCreateTest}
          onEditTest={handleEditTest}
        />
      );
    
    default:
      return (
        <ExamsList 
          exams={exams}
          onDeleteExam={onDeleteExam}
          onViewExam={handleViewExam}
          onCreateExam={handleCreateExam}
        />
      );
  }
};

export default ExamManagement;